import "reflect-metadata";
import {inject, injectable} from "inversify";
import {InternalChatRepository} from "@dropDesk/domain/repositories/internal_chat/internal_chat.repository";
import {ListPaginationEntity} from "@dropDesk/domain/entities/common/list_pagination.entity";
import {InternalChatMessageEntity} from "@dropDesk/domain/entities/internal_chat/messages/internal_chat_message_entity";

@injectable()
export class NavigateToInternalChatMessageUseCase {
    private _repository: InternalChatRepository;

    constructor(@inject(InternalChatRepository) repository: InternalChatRepository) {
        this._repository = repository;
    }

    public call(id: string, idInternalChat: string): Promise<ListPaginationEntity<InternalChatMessageEntity>> {
        return this._repository.navigateToMessage(id, idInternalChat);
    }
}
